import { BaseURL } from '../../../config';

export const CHECKOUT = 'app/HomePage/CHECKOUT';
export const CHECKOUT_SUCCESS = 'app/HomePage/CHECKOUT_SUCCESS';
export const CHECKOUT_ERROR = 'app/HomePage/CHECKOUT_ERROR';

export const EDIT_DISCOUNT_CODE = 'app/HomePage/EDIT_DISCOUNT_CODE';
export const REMOVE_DISCOUNT_CODE = 'app/HomePage/REMOVE_DISCOUNT_CODE';
export const DISCOUNT_CODE_APPLY_SUCCESS =
  'app/HomePage/DISCOUNT_CODE_APPLY_SUCCESS';

// endpoints
export const UPDATE_CART_API = `/cart/update.js?mr=1`;
export const CLEAR_CART_API = `/cart/clear.js`;
export const CHECKOUT_API = `${BaseURL}/app/checkout`;

export const pdpPopupTriggers = ['atc', 'bn'];
export const popupOnAddClickRedirectionFields = [
  'isProductButtonActionGoToPage',
  'isProductButtonActionGoToCart',
  'isProductButtonActionCheckout',
];
